"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableTrials = void 0;

var _trialApi = require("self-service-api/core/api/trialApi");

var _availableTrialsAdapter = _interopRequireDefault(require("self-service-api/adapters/availableTrialsAdapter"));

var getAvailableTrials = function getAvailableTrials() {
  return _trialApi.TrialsApi.getAvailableTrials().then(function (availableTrials) {
    return (0, _availableTrialsAdapter.default)(availableTrials);
  });
};

exports.getAvailableTrials = getAvailableTrials;